import { Skeleton } from "antd";
import Blockies from "react-blockies";
import { useMoralis } from "react-moralis";

/**
 * Shows a blockie image for the provided wallet address
 * @param {*} props
 * @returns <Blockies> JSX Elemenet
 */

function Blockie(props) {
  const { account  } = useMoralis();
  const { accountAddress } = props;
  if (!accountAddress && !account) return <Skeleton.Avatar active size={40} />;
  return (
    <Blockies
      seed={accountAddress ? accountAddress.toLowerCase() : account.toLowerCase()}
      className="identicon"
      {...props}
    />
  );
}

export default Blockie;
